var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01537 13.1878H13.9846C15.3237 13.1878 16 12.5046 16 11.1929V2.81031C16 1.49861 15.3237 0.81543 13.9846 0.81543H2.01537C0.683177 0.81543 0 1.49177 0 2.81031V11.1929C0 12.5114 0.683177 13.1878 2.01537 13.1878ZM0.847139 2.85813C0.847139 2.06564 1.26388 1.66257 2.02904 1.66257H13.971C14.7225 1.66257 15.1529 2.06564 15.1529 2.85813V10.7147L11.3271 7.16214C10.9991 6.88887 10.6644 6.72491 10.2681 6.72491C9.8719 6.72491 9.55081 6.86838 9.22289 7.15531L6.11443 9.93584L4.83006 8.75394C4.54313 8.49434 4.24253 8.35087 3.90094 8.35087C3.57985 8.35087 3.30658 8.4875 3.01964 8.74711L0.847139 10.742V2.85813ZM5.02135 7.10066C5.90265 7.10066 6.62681 6.38332 6.62681 5.48836C6.62681 4.60706 5.90265 3.87606 5.02135 3.87606C4.13322 3.87606 3.40905 4.60706 3.40905 5.48836C3.40905 6.38332 4.13322 7.10066 5.02135 7.10066Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.af156710c66ec8d37927057bdfb5e0f8.svg";
export { ForwardRef as ReactComponent };